import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";
import SubFormWidget from "common/form/widgets/SubFormWidget";

@Form({title: "Course Component Config"})
export class CourseComponentConfig {

	@Input({type: InputType.UNIT, title: "Thumbnail Size"})
	public thumbnailSize?: string;

	@Input({type: InputType.CHECKBOX, title: "Show Progress Bar"})
	public showProgress?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Enable View Details Links"})
	public enableViewDetailsLink?: boolean;
	
	@Input({type: InputType.CHECKBOX, title: "showGroupPurchase"})
	public showGroupPurchase: boolean = true;
}

// used in entries and bundle entries forms for common configuration of the shared item renderer
export const courseComponentConfigInput = SubFormWidget.registerForm(CourseComponentConfig);



// WEBPACK FOOTER //
// ./src/panels/bundleEntries/component/CourseComponentConfig.ts